export const Spinner = ({
  height,
  width,
  fullSize,
  infoText,
}: {
  height?: number;
  width?: number;
  fullSize?: boolean;
  infoText?: string; //Only possible when fullSize
}) => (
  <>
    {fullSize ? (
      <div
        className="flex items-center justify-center flex-col gap-[var(--spacing-xl)]"
        style={{ width: "100%", height: "100%" }}
      >
        <img
          src={require("../../assets/icons/spinner.gif")}
          alt={"Loading..."}
          style={{ height: height ? height : 150, width: width ? width : 150 }}
        />
        <p style={{ font: "var(--font-body-1)" }}>{infoText}</p>
      </div>
    ) : (
      <img
        src={require("../../assets/icons/spinner.gif")}
        alt={"Loading..."}
        style={{ height: height ? height : 150, width: width ? width : 150 }}
      />
    )}
  </>
);
